import { render, staticRenderFns } from "./WhatsappEventsSummary.vue?vue&type=template&id=cc381864&scoped=true&"
import script from "./WhatsappEventsSummary.vue?vue&type=script&lang=js&"
export * from "./WhatsappEventsSummary.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEventsSummary.vue?vue&type=style&index=0&id=cc381864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc381864",
  null
  
)

export default component.exports